import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Header from './Header';
import Menu from './CommonMenu';
import AudioTheoBoPageApi from './AudioTheoBoPageApi';
import { FILE_URL } from './Constants';
import $ from 'jquery';

function AudioTheoBoDetailPage() {
  const [searchParams] = useSearchParams();
  const postId = searchParams.get('postId');
  const [dataChiTiet, setDataChiTiet] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    $('.tlt').textillate({
      loop: true,
      minDisplayTime: 20000,
      in: {
        effect: 'fadeIn',
        delayScale: 3,
        shuffle: false,
      },
      out: {
        effect: 'fadeOut',
        delayScale: 1.5,
        delay: 100,
        sync: false,
        shuffle: false,
        reverse: false,
      }
    });

    $("#sky-bg").fadeIn(2e3);

    if (postId) {
      AudioTheoBoPageApi.getChiTietAudioTheoBoAdmin(postId, 28)
        .then((res) => {
          const detail = Array.isArray(res) && res.length > 0 ? res[0] : (res && res.data && res.data[0]) || null;
          if (detail) {
            const dateStr = detail.date_create || detail.Date_Create;
            if (dateStr) {
              const date = new Date(dateStr);
              detail.formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()}`;
            }
            setDataChiTiet(detail);
          }
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, [postId]);

  return (
    <div>
      <meta httpEquiv="Content-Type" content="text/html; charset=UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1" />
      <meta httpEquiv="Content-Language" content="vi" />
      <title>{dataChiTiet?.title || "Audio Theo Bộ"} | Linh Quy Pháp Ấn</title>
      <link rel="shortcut icon" href="/Upload/images/tab/logochuan.jpg" type="image/png" />

      <div className="fly-text">
        <ul>
          <li className="tlt">Nguyện thành tựu</li>
          <li className="tlt">Lòng tin bất động</li>
          <li className="tlt">Nơi Đức Phật, Chánh Pháp</li>
          <li className="tlt">Chúng Tăng và Thánh Giới</li>
          <li className="tlt" />
        </ul>
      </div>
      <div id="sky-bg">
        <div className="clouds_one" />
        <div className="clouds_two" />
        <div className="clouds_three" />
      </div>
      <Header />
      <section>
        <div className="container contentContainer">
          <div className="row">
            <div className="col-md-9 col-sm-9 col-xs-12">
              <Menu value={"audio"} />
              
              {loading ? (
                <div style={{ padding: '50px 0', textAlign: 'center' }}>Đang tải...</div>
              ) : dataChiTiet ? (
                <div className="row" style={{ marginTop: '20px' }}>
                  <div className="col-md-12 col-sm-12 col-xs-12">
                    <div className="audioContainer" style={{ textAlign: 'center', background: '#f5f5f5', padding: '20px', borderRadius: '8px', border: '1px solid #ddd' }}>
                      {dataChiTiet.thumb && (
                        <img 
                          src={FILE_URL + dataChiTiet.thumb} 
                          alt={dataChiTiet.title} 
                          style={{ maxWidth: '300px', width: '100%', borderRadius: '8px', marginBottom: '15px', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }} 
                        />
                      )}
                      <audio controls autoPlay style={{ width: '100%', marginTop: '10px' }}>
                        <source src={FILE_URL + dataChiTiet.linkAudio} type="audio/mpeg" />
                        Your browser does not support the audio element.
                      </audio>
                    </div>

                    <div className="chiTietVideoAudio" style={{ marginTop: '20px' }}>
                      <div className="row">
                        <div className="col-md-12">
                          <h1 style={{ color: '#80271A', fontSize: '24px', fontWeight: 'bold', borderBottom: '2px solid #FFD21D', paddingBottom: '10px' }}>
                            {dataChiTiet.title}
                          </h1>
                          <p style={{ fontSize: '13px', color: '#666', marginTop: '10px' }}>
                            {dataChiTiet.formattedDate && <span>Ngày đăng: {dataChiTiet.formattedDate}</span>}
                            {dataChiTiet.nguoigiang && <span style={{ marginLeft: '15px' }}>Người giảng: <strong>{dataChiTiet.nguoigiang}</strong></span>}
                          </p>
                          {dataChiTiet.description && (
                            <div style={{ background: '#fafafa', borderLeft: '4px solid #FFD21D', padding: '10px 15px', margin: '15px 0', fontStyle: 'italic' }}>
                              {dataChiTiet.description}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="rich-content" style={{ marginTop: '25px', lineHeight: '1.6', fontSize: '15px' }} dangerouslySetInnerHTML={{ __html: dataChiTiet.content }} />
                  </div>
                </div>
              ) : (
                <div style={{ padding: '50px 0', textAlign: 'center' }}>Không tìm thấy dữ liệu.</div>
              )}
            </div>

            {/* Sidebar tương tự các trang chi tiết khác */}
            <div className="col-md-3 col-sm-3 col-xs-12">
              <div className="boxNews" style={{ marginTop: '20px' }}>
                <div className="containerRightBox">
                  <h5 className="titleRightHome">LIÊN KẾT</h5>
                  <ul className="nav nav-pills nav-stacked listDanhMuc" style={{ padding: '10px 0' }}>
                    <li>
                      <a href="https://www.facebook.com/LINH-QUY-PH%C3%81P-%E1%BA%A4N-260666811038785/" target="_blank" rel="noreferrer">
                        <i className="fa fa-facebook fa-fw" /> Facebook
                      </a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/channel/UCnI54Nrr9AddC4pDdpIjyCg" target="_blank" rel="noreferrer">
                        <i className="fa fa-youtube fa-fw" /> YouTube
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}

export default AudioTheoBoDetailPage;
